// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 132) return "static/chunks/a5d1118a-4e18abbf46a2cd60.js";
	if (chunkId === 901) return "static/chunks/901-4dddfefbeeadb67f.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"d5026d31130b487f","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"88b58403081a489a","367":"d4568facb56ba613","639":"e7b660adfa99260e","748":"3b90ad6e6e9591e5"}[chunkId] + ".js";
};